var pdp_related_swiper = new Swiper(".header-best-swiper", {
    slidesPerView: 2.5,
    spaceBetween: 16,
    freeMode: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },
    scrollbar: {
        el: ".swiper-scrollbar"
    },
});

(function () {
  function processProductLinks() {
    document.querySelectorAll('a.jdgm-rev__prod-link:not(.jdgm-fetched)').forEach(async (link) => {
      link.classList.add('jdgm-fetched');

      const review = link.closest('.jdgm-rev');
      if (!review) return;

      const url = link.getAttribute('href').split('#')[0];
      if (!url) return;

      try {
        const res = await fetch(url);
        const html = await res.text();

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const image = doc.querySelector('.inspired-card__image');
        if (!image) return;

        const brand = doc.querySelector('.inspired-card__brand');

        const wrapper = document.createElement('a');
        wrapper.classList.add('custom-inspire-jdgm');
        wrapper.href = url;
        wrapper.target = '_blank';

        wrapper.appendChild(image);

        if (brand) {
            const labelWrap = document.createElement('div');

            const subtitle = document.createElement('span');
            // subtitle.style.cssText = 'font-size:13px;color:#888;text-transform:uppercase;letter-spacing:0.3px;display:block;margin-bottom:2px;';
            subtitle.textContent = 'Inspirován vůní';

            const brandName = document.createElement('span');
            // brandName.style.cssText = 'font-size:16px;font-weight:500;color:#333;display:block;';
            brandName.textContent = brand.textContent.trim();

            labelWrap.appendChild(subtitle);
            labelWrap.appendChild(brandName);
            wrapper.appendChild(labelWrap);
        }

        review.appendChild(wrapper);
        review.classList.add('has-inspire-card');
      } catch (err) {
        console.error(`Failed to fetch ${url}:`, err);
      }
    });
  }

  processProductLinks();

  const observer = new MutationObserver(processProductLinks);
  observer.observe(document.body, { childList: true, subtree: true });
})();

/* Fix Globo/search inspire-by images → same CDN path as PDP */
(function () {
  if (window.__inspireByImgFixInstalled) return;
  window.__inspireByImgFixInstalled = true;

  function goodUrlForCard(card) {
    var map = window.__INSPIRE_BY_IMG || {};
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return "";
    try {
      var u = new URL(link.getAttribute("href"), location.origin);
      var handle = (u.pathname.split("/products/")[1] || "").split("?")[0].replace(/\/$/, "");
      if (handle && map[handle]) return map[handle];
    } catch (e) {}
    var idAttr = link.id || card.id || "";
    var idMatch = idAttr.match(/(\d{10,})/);
    if (idMatch && map[idMatch[1]]) return map[idMatch[1]];
    return "";
  }

  function needsFix(wrap, img) {
    var text = (wrap && wrap.textContent) || "";
    if (/\/cdn\/shop\/files\/\d+/.test(text)) return true;
    if (/\{\{/.test(text)) return true;
    if (!img) return true;
    var src = img.currentSrc || img.src || "";
    if (/\/cdn\/shop\/files\/\d+(\?|$)/.test(src)) return true;
    if (img.complete && img.naturalWidth === 0 && src) return true;
    return false;
  }

  function fixCard(card) {
    var wrap = card.querySelector(".inspire-img-wrapper");
    if (!wrap) return;
    var img = wrap.querySelector("img");
    if (!needsFix(wrap, img)) return;
    var good = goodUrlForCard(card);
    if (!good) return;
    wrap.innerHTML = '<img class="inspire-img" src="' + good + '" alt="" width="300" height="300" loading="lazy" />';
  }

  function fixAll(root) {
    (root || document).querySelectorAll(".product-card-wrapper, .card-wrapper").forEach(fixCard);
  }

  function boot() {
    fixAll(document);
    var obs = new MutationObserver(function () { fixAll(document); });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    [400, 1200, 2500, 5000].forEach(function (t) { setTimeout(function () { fixAll(document); }, t); });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();

